import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-widget-simulateur-travaux',
    templateUrl: './simulateur-travaux.component.html',
    styleUrls: ['./simulateur-travaux.component.scss']
})
export class SimulateurTravauxComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();

    user: User = Object.assign({}, EMPTY_USER);

    constructor(
        public cityService: CityService,
        public adService: AdService,
        public dialog: MatDialog,
        public authenticationService: AuthenticationService,
        public commonService: CommonService) {
    }

    edit(event, i, fields = '') {
        this.favorite = this.adService.cleanInput(this.favorite);
        if (this.favorite.works_deduc == false) {
            this.favorite.works_not_deduc = 0;
        }

        if (fields === 'works_square_price') {
            this.favorite.lots[i].works_total = null;
        }

        if (fields === 'works_help') {
            this.favorite.lots[i].works_square_price =  this.favorite.lots[i].works_help;
        }

        if (this.favorite.lots.length === 1) {
            this.favorite.works_total = this.favorite.lots[0].works_total;
            this.favorite.works_help = this.favorite.lots[0].works_help;
            this.favorite.works_square_price = this.favorite.lots[0].works_square_price;
        }

        if (this.authenticationService.currentUser.pro_plan == 'oikos') {
            if (fields === 'works_help' || fields === 'works_square_price' || fields === 'works_total') {
                this.favorite.other_fees_work = null;
            }
        }

        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    ngOnInit() {
        this.favorite = this.adService.updateValues(this.favorite);
        this.user = this.authenticationService.currentUser;
    }
}
